module.exports = __webpack_public_path__ + "static/media/job-post-promo-avatar-2.59f909d8.png";